/**
 * @flow
 * @relayHash 0ccae365141625909a3d043a13a602a5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlannerPlaylistSongInput = {
  clientMutationId?: ?string,
  id: string,
};
export type PlannerPlaylist_deletePlannerPlaylistSongMutationVariables = {|
  input: DeletePlannerPlaylistSongInput
|};
export type PlannerPlaylist_deletePlannerPlaylistSongMutationResponse = {|
  +deletePlannerPlaylistSong: ?{|
    +deletedPlannerPlaylistSongId: ?string,
    +planner_playlist: ?{|
      +thumbnail: ?{|
        +id: string,
        +width: ?number,
        +height: ?number,
      |}
    |},
  |}
|};
export type PlannerPlaylist_deletePlannerPlaylistSongMutation = {|
  variables: PlannerPlaylist_deletePlannerPlaylistSongMutationVariables,
  response: PlannerPlaylist_deletePlannerPlaylistSongMutationResponse,
|};
*/


/*
mutation PlannerPlaylist_deletePlannerPlaylistSongMutation(
  $input: DeletePlannerPlaylistSongInput!
) {
  deletePlannerPlaylistSong(input: $input) {
    deletedPlannerPlaylistSongId
    planner_playlist {
      thumbnail(width: 240, height: 240) {
        id
        width
        height
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlannerPlaylistSongInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "DeletePlannerPlaylistSongInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "deletedPlannerPlaylistSongId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "thumbnail",
  "storageKey": "thumbnail(height:240,width:240)",
  "args": [
    {
      "kind": "Literal",
      "name": "height",
      "value": 240,
      "type": "Int"
    },
    {
      "kind": "Literal",
      "name": "width",
      "value": 240,
      "type": "Int"
    }
  ],
  "concreteType": "SongImage",
  "plural": false,
  "selections": [
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PlannerPlaylist_deletePlannerPlaylistSongMutation",
  "id": null,
  "text": "mutation PlannerPlaylist_deletePlannerPlaylistSongMutation(\n  $input: DeletePlannerPlaylistSongInput!\n) {\n  deletePlannerPlaylistSong(input: $input) {\n    deletedPlannerPlaylistSongId\n    planner_playlist {\n      thumbnail(width: 240, height: 240) {\n        id\n        width\n        height\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PlannerPlaylist_deletePlannerPlaylistSongMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deletePlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeletePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [
              v4
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PlannerPlaylist_deletePlannerPlaylistSongMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deletePlannerPlaylistSong",
        "storageKey": null,
        "args": v1,
        "concreteType": "DeletePlannerPlaylistSongPayload",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "planner_playlist",
            "storageKey": null,
            "args": null,
            "concreteType": "PlannerPlaylist",
            "plural": false,
            "selections": [
              v4,
              v3
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '323f8f1370fda0ce3e5d8d0b1f4afb83';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/MusicPlanner/__generated__/PlannerPlaylist_deletePlannerPlaylistSongMutation.graphql.js